import { getHeight, getWidth } from '../../sizes/sizes.alias';
import { getColor } from '../../colors/colors.alias';
import { constants as Label } from '../Label';
import { VARIANT_LARGE, VARIANT_LARGE_INVERTED, VARIANT_MEDIUM, VARIANT_MEDIUM_INVERTED, VARIANT_SMALL, VARIANT_SMALL_INVERTED, ELEMENT_SPINNER_LOADER, ELEMENT_LABEL, } from '../../constants';
export const constants = Object.freeze({
    NAME: 'SpinnerLoader',
    variants: {
        VARIANT_LARGE,
        VARIANT_LARGE_INVERTED,
        VARIANT_MEDIUM,
        VARIANT_MEDIUM_INVERTED,
        VARIANT_SMALL,
        VARIANT_SMALL_INVERTED,
    },
    elements: {
        ELEMENT_SPINNER_LOADER,
        ELEMENT_LABEL,
    },
});
export default function getSpinnerLoader(transformer, config) {
    const color = getColor(transformer, config);
    const height = getHeight(transformer);
    const width = getWidth(transformer);
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_SPINNER_LOADER]: {
                variants: {
                    [VARIANT_SMALL]: {
                        styles: {
                            height: height.spinnerLoader.s.value,
                            width: width.spinnerLoader.s.value,
                        },
                    },
                    [VARIANT_SMALL_INVERTED]: {
                        styles: {
                            height: height.spinnerLoader.s.value,
                            width: width.spinnerLoader.s.value,
                            color: color.icon.inverted.value,
                        },
                    },
                    [VARIANT_MEDIUM]: {
                        styles: {
                            height: height.spinnerLoader.m.value,
                            width: width.spinnerLoader.m.value,
                        },
                    },
                    [VARIANT_MEDIUM_INVERTED]: {
                        styles: {
                            height: height.spinnerLoader.m.value,
                            width: width.spinnerLoader.m.value,
                            color: color.icon.inverted.value,
                        },
                    },
                    [VARIANT_LARGE]: {
                        styles: {
                            height: height.spinnerLoader.l.value,
                            width: width.spinnerLoader.l.value,
                        },
                    },
                    [VARIANT_LARGE_INVERTED]: {
                        styles: {
                            height: height.spinnerLoader.l.value,
                            width: width.spinnerLoader.l.value,
                            color: color.icon.inverted.value,
                        },
                    },
                },
            },
            [ELEMENT_LABEL]: {
                components: {
                    [Label.NAME]: {
                        variant: Label.variants.VARIANT_SUB_LABEL,
                    },
                },
            },
        },
    });
}
